import { render, staticRenderFns } from "./qualityCourse_list.vue?vue&type=template&id=03b4ce44&scoped=true"
import script from "./qualityCourse_list.vue?vue&type=script&lang=js"
export * from "./qualityCourse_list.vue?vue&type=script&lang=js"
import style0 from "./qualityCourse_list.vue?vue&type=style&index=0&id=03b4ce44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b4ce44",
  null
  
)

export default component.exports